import { CheckRideRequestEntity } from "../../../meta-data/app-meta-data.service";
import { ScheduleBlockCalendarEvent } from "../../schedule-blocks/models/schedule-block-calendar-event.model";
import { ScheduleBlockDateRef } from "../../schedule-blocks/models/schedule-block-date-ref.model";
import { CalendarEventDTO } from "./calendar-event.model";

export interface CalendarExtendedData {
    type : CalendarDataType;

    checkride?: CheckRideRequestEntity;
    calendarEvent?: CalendarEventDTO;

    scheduleBlock?: ScheduleBlockCalendarEvent;
    blockDate?: ScheduleBlockDateRef;

    startDateTime: string;
    endDateTime: string;
}


export enum CalendarDataType {
    checkride = 'checkride',
    calendarEvent = 'calendarEvent',
    scheduleBlock = 'scheduleBlock',
    tempBlock = 'tempBlock'
}